
export interface IAdTargetExceptionShortCodes  {
    path: string
    shortcode: string
}
export interface IAdTargetShortCode  {
    [key: string]: string
}

/**
 * AdTargetShortCodes - handles shortcode by domain mapping.
 */
export const AdTargetShortCodes = {
    airdrieecho:'ade',
    bizmagazine:'',
    brantfordexpositor:'brx',
    businesslondon:'',
    calgaryherald:'ch',
    calgarysun:'csun',
    canada :'ccn',
    canoe:'canoe',
    carmanvalleyleader:'tvl',
    chathamdailynews:'cdn',
    chathamthisweek:'ctw',
    classifieds:'gc',
    clintonnewsrecord:'cnr',
    cochranetimes:'cct',
    cochranetimespost:'cbe',
    coldlakesun:'clk',
    communitypress:'cpa',
    countymarket:'ecm',
    countyweeklynews:'cwn',
    dailyheraldtribune:'dht',
    delhinewsrecord:'dnr',
    devondispatch:'dvd',
    draytonvalleywesternreview:'dvw',
    driving:'dr',
    edmontonexaminer:'edx',
    edmontonjournal:'elj',
    edmontonsun:'esun',
    edsonleader:'edl',
    elliotlakestandard:'els',
    faceoff:'',
    fairviewpost:'fvp',
    financialpost:'fp',
    foodandwineexpo:'',
    fortmcmurraytoday:'fmt',
    fortsaskatchewanrecord:'fsr',
    gananoquereporter:'gqr',
    goderichsignalstar:'gss',
    greybrucethisweek:'gbw',
    hamiltonhaltonweddings:'',
    hamiltonmagazine:'',
    hannaherald:'hnh',
    healthing:'healthing',
    highrivertimes:'hrt',
    hintonparklander:'htp',
    homesanddesign:'',
    ingersolltimes:'igt',
    intelligencer:'bvi',
    interlakespectator:'tis',
    interlaketoday:'ils',
    intervin:'',
    kenoradailyminerandnews:'kdm',
    kincardinenews:'kcn',
    kingstonlife:'',
    kingstonthisweek:'ktw',
    lacombeglobe:'lmg',
    lakeshoreadvance:'lsa',
    leaderpost:'rlp',
    leducrep:'ldr',
    lfpress:'lfp',
    lucknowsentinel:'lus',
    mayerthorpefreelancer:'myf',
    melfortjournal:'mfj',
    midnorthmonitor:'emm',
    mitchelladvocate:'mta',
    moderntimes:'mts',
    montrealgazette:'mg',
    nantonnews:'nan',
    napaneeguide:'nap',
    nationalpost:'np',
    niagarafoodandwineexpo:'',
    nipawinjournal:'npj',
    northernnews:'kln',
    nugget:'nbn',
    ontariofarmer:'onf',
    ottawacitizen:'oc',
    ottawasun:'osun',
    owensoundsuntimes:'ows',
    parisstaronline:'prs',
    peacecountrysun:'pcs',
    pembinatoday:'pty',
    pinchercreekecho:'pce',
    portagedailygraphic:'ppg',
    prrecordgazette:'rcg',
    recorder:'bkr',
    redrivervalleyecho:'rre',
    saltwire:'swn',
    sarniathisweek:'slw',
    saultstar:'ssw',
    saultthisweek:'ssm',
    seaforthhuronexpositor:'shx',
    selkirkjournal:'tsl',
    sherwoodparknews:'swp',
    shorelinebeacon:'slb',
    simcoelife:'',
    simcoereformer:'srf',
    sprucegroveexaminer:'sgx',
    stonewallargusteulontimes:'sat',
    stonyplainreporter:'syp',
    stratfordbeaconherald:'sbh',
    strathroyagedispatch:'sad',
    stthomastimesjournal:'stj',
    swervecalgary:'',
    thebeaumontnews:'bmn',
    thecragandcanyon:'bvc',
    thedailyobserver:'pem',
    thegrowthop:'thegrowthop',
    thehomeshow:'',
    thelondoner:'tlo',
    theobserver:'sob',
    theprovince:'vp',
    thestarphoenix:'ssp',
    thesudburystar:'sus',
    thewhig:'kin',
    tillsonburgnews:'tbn',
    timminspress:'tdp',
    timminstimes:'tmt',
    tj:'tj',
    todaysfarmer:'los',
    torontosun:'tsun',
    trentonian:'ttt',
    vancouversun:'vs',
    vermilionstandard:'vms',
    vinesmag:'',
    vulcanadvocate:'vla',
    wallaceburgcourierpress:'wcn',
    wetaskiwintimes:'wtt',
    whitecourtstar:'wcs',
    wiartonecho:'wie',
    windsorstar:'wsr',
    winklertimes:'twt',
    winnipegsun:'wsun',
    woodstocksentinelreview:'wsr',
    working:'wk'
}

/**
 * AdTargetExceptionShortCodes - handle exception shortcode mapping.
 */
export const AdTargetExceptionShortCodes = [
    {
        path: 'legacy/celebration',
        shortcode: 'cel'
    },
    {
        path: 'legacy/obituaries',
        shortcode: 'rem'
    },
    {
        path: 'standard-freeholder',
        shortcode: 'csf'
    },
    {
        path: 'thechronicle-online',
        shortcode: 'wlc'
    },
    {
        path: 'thepost.on',
        shortcode: 'hnp'
    }
]
